import { WalletIcon } from "@heroicons/react/20/solid";
import { useWeb3Modal } from "@web3modal/wagmi/react";
import { useAccount } from "wagmi";
import { formatWalletAddress } from "../utils/wallets";

export function ConnectWalletButton(props: { className?: string }) {
  const { open } = useWeb3Modal();

  const { address } = useAccount();

  if (!address) {
    return (
      <button
        onClick={async () => {
          open();
        }}
        className={
          "flex py-2 px-3 justify-center items-center border-none dark:focus:ring-0 text-white hover:bg-primary-700 bg-gradient-to-r from-[#EF533D] to-[#F39537] rounded-lg text-xs gap-1 focus:ring-4 focus:outline-none focus:ring-primary-300 gradient-flip" +
          (props.className ? " " + props.className : "")
        }
      >
        Connect Wallet <WalletIcon style={{ width: 20, height: 20 }} />
      </button>
    );
  } else
    return (
      <div
        className={
          "flex text-gray-900 dark:text-white text-center justify-center items-center flex-row gap-2" +
          (props.className ? props.className : "")
        }
      >
        <span>Connected to: {formatWalletAddress(address)}</span>
      </div>
    );
}
